import type { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

export const PreviewButton = ({ className, ...props }: JSX.IntrinsicElements['a']) => (
  <a
    {...props}
    className={twMerge(
      'block outline-0 cursor-pointer no-underline p-2 bg-primary text-primary-content rounded border border-transparent',
      className,
    )}
  />
);
